/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssetCopyRequestDto,
  AssetCopyResponseDto,
  AssetFileResponseDto,
  AssetInsertResponseDto,
  AssetResponseDto,
  AssetTransferRequestDto,
  ContentHistoryEntryDto,
  ContentRollbackRequestDto,
  ContentStorage,
  DeleteAssetRequestDto,
  EntityKindDto,
  EntityType,
  OrderRequestDto,
  ProblemDetails,
  TagParentResponseDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Assets<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Retrieves a list of assets based on the provided filter criteria such as team, folder, kind, and tags. **Permissions:** Any authenticated user can retrieve assets. Results are filtered by the provided query parameters. **Returns:** `200 OK` - A list of assets matching the filter criteria. **Error Codes:** `400 BadRequest` - Invalid filter parameters were provided. `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred while retrieving assets.
   *
   * @tags Assets
   * @name AssetsList
   * @summary Get Assets
   * @request GET:/assets
   * @secure
   */
  assetsList = (
    query?: {
      Kind?: string;
      TagIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<AssetResponseDto[], ProblemDetails | void>({
      path: `/assets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows users to upload assets (such as files and thumbnails) to a specified team folder. The asset is validated for size, permissions, and file type before being uploaded to Azure Blob Storage. The response includes the URLs for the asset and thumbnail if uploaded successfully. **Permissions:** Admin and SuperAdmin users can upload without specifying a folder or team. Regular users must provide `FolderId` and `TeamId` and have **Editor** or **Owner** permission in the team-folder relationship (Viewer role is insufficient). **Url / ThumbnailUrl:** A url that points at Trace blob storage is rejected for every role - an asset's bytes are named by the server, either by uploading a file here or by a server-side copy. Only Admin and SuperAdmin may supply a url at all, and only an external one (for example a video link on a library entry). Regular users must upload a file. **Where the bytes go (content model, #912/#932).** A model, image, video or audio upload becomes a *folder*: the file is stored content-addressed at `trace-content/assets/{assetId}/assets/<slug>.<hash16>.<ext>` and **the row's url is that file** - no document is generated (spec §3.1). `<slug>` comes from the uploaded file name and `<hash16>` is the first 16 hex characters of its SHA-256. The asset's kind is still the uploaded file's - a .glb is a Model, a .png an Image - and `GET /assets/{id}/file` redirects to it. The first editor that authors a behavior on the asset (or adds a second file) PATCHes a document naming that same file, and the row repoints; the server never authors a document. **Uploading a document instead of a leaf.** Send the `.gltf` document as `File` and each file it references as a repeated `Files` part. Every relative `files[k].uri` must be a name this folder already holds - one learned from `POST /assets/{id}/files`, from a previous document, or predicted with the public slug rule. A mismatch is `400` with a body carrying `files: [ { index, authored, stored } ]`, where `stored` is the relative uri the matching part was actually stored under (or null): repoint those entries and send the same document again. The document is stored **byte for byte** as uploaded and its hash is the hash of your bytes - the server never rewrites or re-serializes it. A `.glz` bundle is the packed form of the same thing (content model spec §4): send it as `File` with no `Files`, and the server unzips `scene.gltf` plus the `assets/` beside it, re-hashing the entries. The pre-v4 spelling `.tracex` is the same container and takes the same path; a bundle whose root document is the legacy `scene.glxf` is accepted and stored as-is on the raw-blob path instead, until the `.glxf` reader retires. Every file the document names must be a file of this folder, a library asset (`/assets/{guid}/file`) or streamable media on a foreign host - an asset may never reference a scene folder. **metadata.behaviors** is dropped on write: behaviors live in the document, not on the row (unless `contentStorage=Legacy`, below). **`contentStorage` (optional) — how these bytes are stored.** `Folder` is the content model: a leaf is stored content-addressed and the row points at the file, a `.glz`/`.tracex` bundle is unzipped into the same layout (the one path whose document IS rewritten, because bundle import is the source→hosted boundary), and a `.gltf` document is validated against the folder and stored as sent. `Legacy` is the pre-content-model shape: a leaf or a bundle goes raw to `trace-cms-assets` as `{guid}.{ext}` and the row points at the blob. **Omit it and the environment decides** (`ContentOptions:LegacyWrites`), which is why new clients should send `Folder` for their **leaf** uploads — an environment still defaulting to `Legacy` would otherwise store those in the old shape. A **document** upload needs no value: a `.gltf` can only be a folder, so it takes the folder path whatever the environment defaults to. Sending `Legacy` *with* a document is `400` — there is no raw form of one, and the server will not pick one silently. Fonts, JSON and legacy `.trace` archives are stored raw whichever value is sent. The value also decides `metadata.behaviors`: stripped under `Folder`, kept under `Legacy`. **Returns:** `200 OK` - The asset and thumbnail are successfully uploaded, with URLs for access. **Error Codes:** `400 BadRequest` - Invalid request, permission denied, or validation failure (e.g., file size exceeded, missing FolderId/TeamId for non-admin users, insufficient team-folder role, an unrecognised `contentStorage`, a `.gltf` document sent with an explicit `contentStorage=Legacy`, or a document naming files the folder does not hold - that one carries `files: [ { index, authored, stored } ]` in the body). `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred during file upload.
   *
   * @tags Assets
   * @name AssetsCreate
   * @summary Upload an Asset (images,videos or glb models)
   * @request POST:/assets
   * @secure
   */
  assetsCreate = (
    data: {
      /** @format uuid */
      FolderId?: string;
      /** @format uuid */
      TeamId?: string;
      /** @format binary */
      File?: File;
      /** @format binary */
      Thumbnail?: File;
      Files?: File[];
      Title: string;
      Description?: string;
      Metadata?: string;
      Url?: string;
      ThumbnailUrl?: string;
      EntityType?: EntityType;
      Tags?: string[];
      /** @format double */
      Duration?: number;
      ContentStorage?: ContentStorage;
    },
    params: RequestParams = {},
  ) =>
    this.request<AssetInsertResponseDto, ProblemDetails | void>({
      path: `/assets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Hashes the upload and stores it at `trace-content/assets/{assetId}/assets/<slug>.<hash16>.<ext>`, returning the **relative** uri the asset's document references it by. The twin of `POST /scenes/{sceneId}/files` (content model spec §2.4). **Restrictions:** - **Validation**: A non-empty `File` is required, and its type must be one the platform stores (the same allowlist every other upload path uses). - **Asset Validation**: The asset must exist and not be deleted. - **Permission**: Exactly `PATCH /assets/{assetId}`'s gate - `Editor` or `Owner` on the team-folder the asset lives in (send `TeamId`), or an Admin/SuperAdmin role for a folderless admin-library asset. **Behavior:** - **No row is touched.** This writes bytes into the folder; the client then PATCHes a document naming the returned uri, and *that* write repoints the row. It is how an unedited leaf asset gains a second file or a behavior (spec §3.1, "wrap on first edit"). - The name is minted by the server and nothing else: `<slug>` from this upload's file name, `<hash16>` the first 16 hex characters of its SHA-256. Importing the same bytes under the same name twice writes once - a name collision is not an error, the response is `200 OK` with `alreadyExisted: true`. - The returned `uri` is relative (`assets/<slug>.<hash16>.<ext>`) on purpose - a reader resolves it against the document's own URL, which is what lets an asset folder be copied, downloaded, zipped and re-uploaded with no rewriting. - The response also carries `name`, this upload's own file name, for the client to write into `files[k].name` - the human label storage never keeps (spec §2.1). **Outcome:** - On success, returns HTTP `200 OK` with an `AssetFileResponseDto`. - If validation fails, the asset is not found, or the caller lacks edit permission, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`.
   *
   * @tags Assets
   * @name FilesCreate
   * @summary Import a file into an asset's folder
   * @request POST:/assets/{assetId}/files
   * @secure
   */
  filesCreate = (
    assetId: string,
    data: {
      /** @format binary */
      File?: File;
      /** @format uuid */
      TeamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AssetFileResponseDto, ProblemDetails | void>({
      path: `/assets/${assetId}/files`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description The asset folder's retained documents, newest first (content model spec §2.8): `[ { version, url, createdAt, parent, current } ]`. **What a version is.** Every save writes a new immutable document into the folder and repoints the row; the old ones stay for the retention window (`BlobSweep:HistoryDays`, default 30 days, and never fewer than the newest `BlobSweep:HistoryMinDocuments`, default 5). There is no version table - the folder is the history, and this endpoint enumerates it. - `version` is the document's full SHA-256 and is what `POST /assets/{assetId}/rollback` names. It is `null` only for a document old enough to carry neither the metadata nor the digest in its name; such an entry is listed but cannot be rolled back to. - `parent` is the `version` of the document that was current when this one was written - the chain. `null` when there was none, or when the parent has already fallen out of the window. - `current` marks the one the row points at. An **unedited leaf** asset (spec §3.1) points at its *file*, not a document, so its history is empty until the first edit writes one - that is the honest answer, not an error. - `url` is immutable and cacheable forever; a rolled-back scene shows a referenced asset's *current* state either way (§3.4). **Permissions:** the asset's **read** gate - the same one `GET /assets/{assetId}` applies. **Returns:** `200 OK` - the versions, newest first. Possibly empty. **Error Codes:** `400 BadRequest` - no such asset, or the caller has no claim to it. Answered identically on purpose. `401 Unauthorized` - User is not authenticated.
   *
   * @tags Assets
   * @name HistoryList
   * @summary List an Asset's versions
   * @request GET:/assets/{assetId}/history
   * @secure
   */
  historyList = (assetId: string, params: RequestParams = {}) =>
    this.request<ContentHistoryEntryDto[], ProblemDetails | void>({
      path: `/assets/${assetId}/history`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Points the asset's row back at a document the folder still holds (content model spec §2.8). Body: `{ "version": "<full sha256>", "teamId": "<guid>" }`. **A rollback is a repoint.** No document is written, no bytes move, and no `parent` is rewritten: the chain records what was *saved* and the row records what is *current*, so a rollback shows up as the pointer sitting on an older node. The next save stamps `parent` = the document you rolled back to, which leaves the abandoned branch listed until the window closes. **What is checked first**, in order, and any of them refuses without touching the row: - the version is still in the folder (`404` otherwise - it never was, or the retention window closed on it); - every relative file that document names is still there (`400` with `files: [ { index, authored, stored } ]`, `stored` null); - its manifest still validates (§2.5) - a **library asset it references may have been deleted since**, and that fails the rollback rather than dangling. The `400` message names the offending `files[i]` index and why. The closure rule is on: an asset document may never reference a scene folder. **Permissions:** a **save** - exactly `PATCH /assets/{assetId}`'s gate (`Editor`/`Owner` on the asset's team-folder, or an admin role for a folderless admin-library asset). **Returns:** `200 OK` - the version that is now current. **Error Codes:** `400 BadRequest` - no such asset, no permission, no version given, or the document can no longer be validated. `401 Unauthorized` - User is not authenticated. `404 NotFound` - the folder does not hold that version.
   *
   * @tags Assets
   * @name RollbackCreate
   * @summary Roll an Asset back to an earlier version
   * @request POST:/assets/{assetId}/rollback
   * @secure
   */
  rollbackCreate = (
    assetId: string,
    data: ContentRollbackRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ContentHistoryEntryDto, ProblemDetails | void>({
      path: `/assets/${assetId}/rollback`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves detailed information about a specific asset by its asset ID. It includes related user information, such as the user who owns the asset and the associated user account details. **Permissions:** For an asset in a folder, the caller must belong to one of the teams that folder is granted to (Viewer is enough), or hold an admin/support role. Admin-library assets (no folder) stay readable by any authenticated caller, except that non-Live statuses are admin-only. **Returns:** `200 OK` - The asset details are successfully retrieved. **Error Codes:** `400 BadRequest` - The specified asset could not be found, or the caller has no claim to it. The two are answered identically on purpose, so the endpoint does not confirm which asset ids exist. `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred while fetching the asset.
   *
   * @tags Assets
   * @name AssetsDetail
   * @summary Get an Asset by ID
   * @request GET:/assets/{assetId}
   * @secure
   */
  assetsDetail = (assetId: string, params: RequestParams = {}) =>
    this.request<AssetResponseDto, ProblemDetails | void>({
      path: `/assets/${assetId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows the user to partially update the details of an asset by its ID. The update is carried out based on the provided data in the `AssetUpdateRequestDto`. **Clearing a file:** Omitting `File` leaves the existing file alone. To remove it, send `ClearFile=true` (or `ClearThumbnail=true`); sending both a file and the matching clear flag is rejected. Clearing detaches the asset from its blob and does not delete the blob. **Url / ThumbnailUrl:** Same rule as `POST /assets` - never a Trace blob storage url, and only Admin/SuperAdmin may supply an external one. **Replacing the file:** the new bytes are written under their own name and the row is repointed - the old blob is never overwritten or deleted. A leaf, a `.gltf` document with its `Files`, or a `.glz` bundle (`.tracex` under its pre-v4 spelling), exactly as on `POST /assets`. **metadata.behaviors** is dropped on write: behaviors live in the document, not on the row (unless `contentStorage=Legacy`, below). **`contentStorage` (optional) — how these bytes are stored.** `Folder` is the content model: a leaf is stored content-addressed and the row points at the file (no document is generated, spec §3.1), a `.glz`/`.tracex` bundle is unzipped into the same layout, and a `.gltf` document is validated against the folder and stored as sent. `Legacy` is the pre-content-model shape: a leaf or a bundle goes raw to `trace-cms-assets` as `{guid}.{ext}` and the row points at the blob. **Omit it and the environment decides** (`ContentOptions:LegacyWrites`), which is why new clients should send `Folder` for their **leaf** uploads — an environment still defaulting to `Legacy` would otherwise store those in the old shape. A **document** upload needs no value: a `.gltf` can only be a folder, so it takes the folder path whatever the environment defaults to. Sending `Legacy` *with* a document is `400` — there is no raw form of one, and the server will not pick one silently. Fonts, JSON and legacy `.trace` archives are stored raw whichever value is sent. The value also decides `metadata.behaviors`: stripped under `Folder`, kept under `Legacy`. **Permissions:** If the asset belongs to a folder, the user must have **Editor** or **Owner** permission in the team-folder relationship. Admin and SuperAdmin users can update assets without folder restrictions. **Returns:** `200 OK` - The asset was successfully updated and the updated details are returned. **Error Codes:** `400 BadRequest` - The asset was not found, invalid input data was provided, the url points at Trace blob storage or is supplied by a non-admin, a file was combined with a request to clear it, an unrecognised `contentStorage` was sent or a `.gltf` document was sent with `contentStorage=Legacy`, or the user lacks Editor/Owner permission in the team-folder relationship. `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred while updating the asset.
   *
   * @tags Assets
   * @name AssetsPartialUpdate
   * @summary Update an Asset by ID
   * @request PATCH:/assets/{assetId}
   * @secure
   */
  assetsPartialUpdate = (
    assetId: string,
    data: {
      /** @format uuid */
      FolderId?: string;
      /** @format uuid */
      TeamId?: string;
      Title?: string;
      Description?: string;
      Metadata?: string;
      Url?: string;
      ThumbnailUrl?: string;
      Tags?: string[];
      /** @format binary */
      Thumbnail?: File;
      /** @format binary */
      File?: File;
      /** @format double */
      Duration?: number;
      Files?: File[];
      ClearFile?: boolean;
      ContentStorage?: ContentStorage;
      ClearThumbnail?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<AssetResponseDto, ProblemDetails | void>({
      path: `/assets/${assetId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows the user to delete an asset by its ID. The request also requires a `DeleteAssetRequestDto` which includes the team ID to check permissions. The asset's associated files are deleted from Azure Blob Storage, and the asset is removed from the database. **Permissions:** Admin and SuperAdmin users can delete any asset. Regular users must provide `TeamId` in the request body and have **Editor** or **Owner** permission in the team-folder relationship. **Returns:** `204 No Content` - The asset was successfully deleted. **Error Codes:** `400 BadRequest` - The asset was not found, invalid input data was provided, or the user lacks Editor/Owner permission for the asset's team-folder. `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred while deleting the asset.
   *
   * @tags Assets
   * @name AssetsDelete
   * @summary Delete an Asset by ID
   * @request DELETE:/assets/{assetId}
   * @secure
   */
  assetsDelete = (
    assetId: string,
    data: DeleteAssetRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/assets/${assetId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Redirects (`302`) to whatever the asset's row currently points at: its **document**, or - for a leaf that has never been edited (spec §3.1) and for a legacy raw row - **the file itself**. This is the stable, live reference to a library asset: a scene document names `/assets/{assetId}/file` and a generic client follows the redirect, so editing the asset repoints every scene that references it and there is no version in the reference to go stale. A reader classifies by what the redirect resolved to, never by the name. **Caching (content model spec §2.7).** The redirect is conditional, not uncacheable: - `Cache-Control: public, max-age=60` - a shared cache may serve it for a minute, which is the longest an asset edit takes to reach a scene that references it. - `ETag: "<version token>"` - the last path segment of the current url without its extension (`scene.<hash16>` for a folder document, `<slug>.<hash16>` for an unedited leaf, the blob guid for a legacy row). All are write-once, so it is a **strong** validator: same token, same bytes. - `Last-Modified` - the row's modification time, RFC 1123. - `If-None-Match` (strong compare) and `If-Modified-Since` are honoured with `304 Not Modified`, carrying the same three headers and no `Location`. A `304` means the reference still points where the client last saw it, so the whole document tree behind it stays valid. - No `Vary`: the response does not depend on the caller, so a CDN can cache it. The blob the `Location` names is immutable and cacheable by url forever. An asset whose url is external (a Learn resource's video link, say) redirects to it as authored. **Permissions:** **Anonymous — no authentication required, and none is wanted** (content model spec §3.4). A generic glTF client follows this redirect with a bare GET; an `Authorization` header would ride the `302` into blob storage and be rejected there. The only gates are that the row exists, is not deleted, and has a file — there is no per-caller read check, because the bytes behind it are already public by URL (legacy assets sit in a public container under their own guid). Unguessable ids are what keeps them unlisted. The row read at `GET /assets/{assetId}`, which returns the title, metadata and creator, is authorized as before. **Returns:** `302 Found` - `Location` is the file's absolute url. `304 Not Modified` - the caller's `If-None-Match`/`If-Modified-Since` still match the row; no `Location` is sent. **Error Codes:** `404 NotFound` - No such asset, the asset is deleted, or it carries no file. All three are answered identically on purpose, so the redirect does not confirm which asset ids exist.
   *
   * @tags Assets
   * @name FileList
   * @summary Follow an Asset to its file
   * @request GET:/assets/{assetId}/file
   * @secure
   */
  fileList = (assetId: string, params: RequestParams = {}) =>
    this.request<any, void | ProblemDetails>({
      path: `/assets/${assetId}/file`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Redirects (`302`) to the file of the asset's **current** document whose `files[k].name` equals `{name}` - the human name, the one that was dropped in, not the stored one (content model spec §2.4). **This is "latest by plain name" at the API, with no mutable blob behind it.** Storage names are immutable and content-addressed (`<slug>.<hash16>.<ext>`) precisely so a CDN can cache them forever and an old document still says which bytes it meant; the cost is that nobody can *type* one. This endpoint pays that cost at the API instead: it re-reads the row and its current document on every request, so what it answers moves when the asset is edited, while the blob it points at never does. **Readers never use it.** A document's `files[k].uri` is the resolver, and it is already the exact bytes that document meant. This is for tools, scripts and people: `curl` a poster out of an asset by the name it was uploaded under. **Matching:** exact first over the whole document, then case-insensitive over the whole document; the first match wins. `{name}` = `scene.gltf` answers **the document itself** (the name the `.glz` bundle's root entry carries, §4). For an **unedited leaf** asset (§3.1, no document) the file answers to the name the row recorded at upload (`originalFilename`) or to its own stored name. Only this folder's own files resolve: an entry naming a library asset or a foreign stream is an absolute reference rather than a file of this folder, and a name that only matches one of those is a `404`. **Caching:** identical to `GET /assets/{assetId}/file` - `Cache-Control: public, max-age=60`, a strong `ETag` (the target's version token), `Last-Modified`, and `304` on `If-None-Match` / `If-Modified-Since`. **Permissions:** **anonymous**, exactly like `GET /assets/{assetId}/file`. **Returns:** `302 Found` - `Location` is the file's absolute url. `304 Not Modified` - the caller's validators still match; no `Location` is sent. **Error Codes:** `404 NotFound` - no such asset, it is deleted, it has no folder, or nothing in its current document answers to that name. All answered identically on purpose.
   *
   * @tags Assets
   * @name FilesDetail
   * @summary Follow an Asset to one of its files by plain name
   * @request GET:/assets/{assetId}/files/{name}
   * @secure
   */
  filesDetail = (assetId: string, name: string, params: RequestParams = {}) =>
    this.request<any, void | ProblemDetails>({
      path: `/assets/${assetId}/files/${name}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Replaces the file of an existing asset with the file from another asset. The source asset's file is copied to the target asset, and the updated target asset details are returned. **Permissions:** **Admin** or **SuperAdmin** only. Both assets are addressed by id with no folder or team scoping, so there is no per-asset permission to fall back on. **Returns:** `200 OK` - The asset file was successfully swapped and updated details are returned. **Error Codes:** `400 BadRequest` - One or both assets could not be found. `401 Unauthorized` - User is not authenticated. `403 Forbidden` - The caller is not an Admin or SuperAdmin. `500 InternalServerError` - Unexpected error occurred during the file swap.
   *
   * @tags Assets
   * @name SwapPartialUpdate
   * @summary Swap an Asset File
   * @request PATCH:/assets/{assetId}/swap/{swapAssetId}
   * @secure
   */
  swapPartialUpdate = (
    assetId: string,
    swapAssetId: string,
    params: RequestParams = {},
  ) =>
    this.request<AssetResponseDto, ProblemDetails | void>({
      path: `/assets/${assetId}/swap/${swapAssetId}`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a copy of the source asset as a new row in the destination folder, pointing at the source's stored file and thumbnail - no bytes move, so it is O(1) for any file size and works for file-less sources. The source must be curated library content the caller can see, or in a folder the caller can read; the destination folder must be held by the team with a non-Viewer permission. Counts against the team's asset limit. `mode` is required: `existing` returns the team's existing copy of the source's lineage root if it has one (`created: false`), otherwise creates one; `new` always creates one. An `Idempotency-Key` header makes a retried request return the same copy. The copy takes the source's content kind (a Template or Showcase becomes a Trace), carries the lineage (`templateAssetId` root, `copiedFrom` parent), and none of the source's library tags.
   *
   * @tags Assets
   * @name CopyCreate
   * @summary Copy an asset into the caller's team (server-side, no file transfer)
   * @request POST:/assets/{assetId}/copy
   * @secure
   */
  copyCreate = (
    assetId: string,
    data: AssetCopyRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<AssetCopyResponseDto, ProblemDetails>({
      path: `/assets/${assetId}/copy`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns every non-deleted asset in the team whose lineage root is the source's (a copy of a copy counts). Empty when the team has none. The caller must be able to read the source and be a member of the team.
   *
   * @tags Assets
   * @name CopiesList
   * @summary The team's existing copies of an asset
   * @request GET:/assets/{assetId}/copies
   * @secure
   */
  copiesList = (
    assetId: string,
    query?: {
      /** @format uuid */
      teamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AssetResponseDto[], ProblemDetails>({
      path: `/assets/${assetId}/copies`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Moves an asset into a folder owned by a **different** team and reassigns ownership to that team's creator user. To move an asset between folders within the same team, use `PATCH /assets/{assetId}` instead. **Permissions:** SuperAdmin can transfer any asset. Regular users must be the creator owner (IsCreator) of both the source folder's team and the destination folder's team. **Returns:** `204 No Content` on success. **Error Codes:** `400 BadRequest` - Asset or destination folder not found, the asset has no source folder, source and destination are the same folder, or both folders belong to the same team (use PATCH instead). `403 Forbidden` - Caller is not authorized to transfer between these teams. `409 Conflict` - The destination team's asset limit would be exceeded. `500 InternalServerError` - Unexpected server-side error.
   *
   * @tags Assets
   * @name TransferCreate
   * @summary Transfer an Asset to another team's folder
   * @request POST:/assets/{assetId}/transfer
   * @secure
   */
  transferCreate = (
    assetId: string,
    data: AssetTransferRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/assets/${assetId}/transfer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This endpoint updates the order (index) of existing assets. Each asset is identified by its `Id`, and a new `Index` is provided for sorting. **Permissions:** **Admin** or **SuperAdmin** only - this is the curated ordering of the admin library, and the ids in the body are not scoped to a folder or team. **Requirements:** - The request must include a list of asset IDs with their corresponding new indices. **Returns:** `204 No Content` - The asset order was successfully updated. **Error Codes:** `400 BadRequest` - Invalid request data or one or more assets could not be found. `401 Unauthorized` - User is not authenticated. `403 Forbidden` - The caller is not an Admin or SuperAdmin. `500 InternalServerError` - Unexpected error occurred while reordering assets.
   *
   * @tags Assets
   * @name OrderPartialUpdate
   * @summary Reorder existing assets
   * @request PATCH:/assets/order
   * @secure
   */
  orderPartialUpdate = (data: OrderRequestDto[], params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/assets/order`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves the list of available asset kinds (e.g., 3D models, images, videos). **Permissions:** Public endpoint - no authentication required (AllowAnonymous). **Returns:** `200 OK` - A list of available asset kinds. **Error Codes:** `400 BadRequest` - Invalid request. `500 InternalServerError` - Unexpected error occurred while retrieving asset kinds.
   *
   * @tags Assets
   * @name KindsList
   * @summary Get Asset Kinds
   * @request GET:/assets/kinds
   * @secure
   */
  kindsList = (params: RequestParams = {}) =>
    this.request<EntityKindDto[], ProblemDetails | void>({
      path: `/assets/kinds`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new tag that can be associated with assets for categorization and filtering. **Permissions:** Tags come in two tiers. **Curated** tags (no owner) are the shared vocabulary every team sees; writing them is **Admin**\/**SuperAdmin** only. **Team-owned** terms are created by supplying `TeamId` with `ParentTagIds`: the caller must be an Editor/Owner of that team (admins exempt), the parent category must allow team terms, and the term is then visible to and writable by that team only. Creating a **category** (no `ParentTagIds`) is always curated and admin-only; `AllowTeamTerms` (default true) controls whether teams may add terms under it. A non-admin creating a term without `TeamId` gets `403`. **Returns:** `204 No Content` - The tag was successfully created. **Error Codes:** `400 BadRequest` - Invalid request data (e.g., missing tag name, or - when `Strict` is set - a parent category that no longer exists). `401 Unauthorized` - User is not authenticated. `403 Forbidden` - A non-admin attempted to create a category or a curated term, or the parent category does not accept team terms. `409 Conflict` - `Strict` was set and a tag with this name already exists under the requested parent (a curated term of the same name counts). `500 InternalServerError` - Unexpected error occurred while creating the tag.
   *
   * @tags Assets
   * @name TagsCreate
   * @summary Create a Tag
   * @request POST:/assets/tags
   * @secure
   */
  tagsCreate = (
    data: {
      Name?: string;
      /** @format binary */
      File?: File;
      EntityTypes?: EntityType[];
      ParentTagIds?: string[];
      BgColor?: string;
      Strict?: boolean;
      /** @format uuid */
      TeamId?: string;
      AllowTeamTerms?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/assets/tags`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description Retrieves all available tags, optionally filtered by asset kind. **Permissions:** Any authenticated user. Returns the curated vocabulary plus the caller's own teams' terms; the org-content admin tiers see every team's terms. **Returns:** `200 OK` - A list of all tags, optionally filtered by the specified kind. **Error Codes:** `400 BadRequest` - Invalid filter parameter. `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred while retrieving tags.
   *
   * @tags Assets
   * @name TagsList
   * @summary Get All Tags
   * @request GET:/assets/tags
   * @secure
   */
  tagsList = (
    query?: {
      kind?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TagParentResponseDto[], ProblemDetails | void>({
      path: `/assets/tags`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing tag's details such as name or icon. **Permissions:** Curated tags and categories: **Admin**\/**SuperAdmin** only - a rename rewrites a label every team already sees on its assets. Team-owned terms: also any Editor/Owner of the owning team. **Returns:** `204 No Content` - The tag was successfully updated. **Error Codes:** `400 BadRequest` - The tag was not found or invalid input data was provided. `401 Unauthorized` - User is not authenticated. `403 Forbidden` - The caller may not write this tag (curated tag as a non-admin). `500 InternalServerError` - Unexpected error occurred while updating the tag.
   *
   * @tags Assets
   * @name TagsPartialUpdate
   * @summary Update a Tag
   * @request PATCH:/assets/tags/{tagId}
   * @secure
   */
  tagsPartialUpdate = (
    tagId: string,
    data: {
      Name?: string;
      /** @format binary */
      File?: File;
      EntityTypes?: EntityType[];
      ParentTagIds?: string[];
      BgColor?: string;
      Strict?: boolean;
      /** @format uuid */
      TeamId?: string;
      AllowTeamTerms?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/assets/tags/${tagId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description Retrieves the details of a specific tag including its parent information. **Permissions:** Any authenticated user. Team-owned terms are only returned to members of the owning team (and the org-content admin tiers); anyone else gets `400` not found. **Returns:** `200 OK` - The tag details are successfully retrieved. **Error Codes:** `400 BadRequest` - The specified tag could not be found. `401 Unauthorized` - User is not authenticated. `500 InternalServerError` - Unexpected error occurred while fetching the tag.
   *
   * @tags Assets
   * @name TagsDetail
   * @summary Get a Tag by ID
   * @request GET:/assets/tags/{tagId}
   * @secure
   */
  tagsDetail = (tagId: string, params: RequestParams = {}) =>
    this.request<TagParentResponseDto, ProblemDetails | void>({
      path: `/assets/tags/${tagId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an existing tag by its ID. The tag will no longer be available for asset categorization. **Permissions:** Curated terms and categories: **Admin**\/**SuperAdmin** only - the delete cascades off every asset, scene and project platform-wide. Team-owned terms: also any Editor/Owner of the owning team. **Returns:** `204 No Content` - The tag was successfully deleted. **Error Codes:** `400 BadRequest` - The specified tag could not be found. `401 Unauthorized` - User is not authenticated. `403 Forbidden` - A non-admin attempted to delete a curated tag. `500 InternalServerError` - Unexpected error occurred while deleting the tag.
   *
   * @tags Assets
   * @name TagsDelete
   * @summary Delete a Tag
   * @request DELETE:/assets/tags/{tagId}
   * @secure
   */
  tagsDelete = (tagId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/assets/tags/${tagId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
